import { render, staticRenderFns } from "./ProjectFileCategoriesContainer.vue?vue&type=template&id=4b51821c&scoped=true&lang=pug&"
import script from "./ProjectFileCategoriesContainer.vue?vue&type=script&lang=js&"
export * from "./ProjectFileCategoriesContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFileCategoriesContainer.vue?vue&type=style&index=0&id=4b51821c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51821c",
  null
  
)

export default component.exports